<!--
  DO NOT CHANGE the weird formatting between the TableCell tags. It is necessary to
  suppress the horizontal space introduced between inline-block elements by the browser.
-->
<template>
  <TableRow
    class="cruise-list-header-table-row bg-sachlich-white" 
    :style="`min-width: ${rowWidth}px;`"
  >
    <SortableTableCell 
      label="ABFAHRT"
      :width="columnWidths.abfahrt"
      :sort-by="sortKeys.abfahrt"
    /><SortableTableCell 
      label="ROUTE"
      :width="columnWidths.route"
      :sort-by="sortKeys.route"
    /><TableCell 
      :width="`${columnWidths.dauer}px`"
      class="table-cell-header text-center fw-bold color-expinet-blue p-2 position-relative text-center"
    >
      <span><i class="fa fa-calendar" /></span>
    </TableCell><TableCell
      :width="`${columnWidths.schiff}px`"
      class="table-cell-header text-center fw-bold color-expinet-blue p-2 position-relative text-center"
    >
      <span>
        <i
          ref="cruise-list-header-icon-schiff"
          class="position-relative fa fa-ship"
          @mouseover="displayTooltip('cruise-list-header-icon-schiff')"
          @mouseleave="hideTooltip('cruise-list-header-icon-schiff')"
        />
      </span>
    </TableCell><TableCell 
      :width="`${columnWidths.flüge}px`" 
      class="table-cell-header fw-bold color-expinet-blue p-2 position-relative d-inline-block"
    >
      <span>FLÜGE</span>
    </TableCell><TableCell
      :width="`${columnWidths.bett}px`"
      class="table-cell-header text-center fw-bold color-expinet-blue p-2 position-relative text-center"
    >
      <span>
        <i
          ref="cruise-list-header-icon-bett"
          class="position-relative fa fa-bed"
          @mouseover="displayTooltip('cruise-list-header-icon-bett')"
          @mouseleave="hideTooltip('cruise-list-header-icon-bett')"
        />
      </span>
    </TableCell><SortableTableCell 
      :label="priceModelLabel(sortKeys.comfortai)"
      :width="columnWidths.comfort_all_inclusive"
      :sort-by="sortKeys.comfortai"
      :is-price-model-cell="true"
      tooltip-id="cruise-list-header-icon-comfort-all-inclusive"
    /><SortableTableCell 
      :label="priceModelLabel(sortKeys.premiumai)"
      :width="columnWidths.premium_all_inclusive"
      :sort-by="sortKeys.premiumai"
      :is-price-model-cell="true"
      tooltip-id="cruise-list-header-icon-premium-all-inclusive"
    /><SortableTableCell 
      :label="priceModelLabel(sortKeys.premium)"
      :width="columnWidths.premium"
      :sort-by="sortKeys.premium"
      :is-price-model-cell="true"
      tooltip-id="cruise-list-header-icon-premium"
    /><SortableTableCell 
      :label="priceModelLabel(sortKeys.classicai)"
      :width="columnWidths.classic_all_inclusive"
      :sort-by="sortKeys.classicai"
      :is-price-model-cell="true"
      tooltip-id="cruise-list-header-icon-classic-all-inclusive"
    /><SortableTableCell 
      :label="priceModelLabel(sortKeys.classic)"
      :width="columnWidths.classic"
      :sort-by="sortKeys.classic"
      :is-price-model-cell="true"
      tooltip-id="cruise-list-header-icon-classic"
    /><TableCell
      :width="`${columnWidths.specials}px`"
      class="table-cell-header text-center fw-bold color-expinet-blue p-2 position-relative"
    >
      <span>
        <i
          ref="cruise-list-header-icon-specials"
          class="position-relative fa fa-info-circle"
          @mouseover="displayTooltip('cruise-list-header-icon-specials')"
          @mouseleave="hideTooltip('cruise-list-header-icon-specials')"
        />
        WEITERE TARIFE
      </span>
    </TableCell><TableCell
      :width="`${columnWidths.button}px`"
      class="table-cell-header"
    />
  </TableRow>
</template>

<script lang="ts">
import { useUiStore } from '@/store'
import { mapPriceModelLabel } from '@/store/details/helper'
import { IbePriceModelCode } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'
import { COLUMN_WIDTHS, SORT_KEYS } from '../../general/helper'
import SortableTableCell from './SortableTableCell.vue'
import TableCell from './TableCell.vue'
import TableRow from './TableRow.vue'

export default defineComponent({
  components: { TableRow, TableCell, SortableTableCell },

  props: {
    rowWidth: { type: Number, default: 0}
  },

  data: () => {
    return {
      columnWidths: COLUMN_WIDTHS,
      sortKeys: SORT_KEYS,
    }
  },
  
  methods: {
    ...mapActions(useUiStore, {
      hideTooltip: 'hideTooltip',
      showTooltip: 'showTooltip'
    }),
    
    displayTooltip(name: string) {
      const rect = (this.$refs[name] as HTMLElement).getBoundingClientRect()
      
      // TODO: make this dynamic
      const pos = { x: this.getPosition(name, rect.left), y: rect.top }

      this.showTooltip({ name, pos })
    },
    getPosition: (name: string, position: number) => {
      switch(name) {
        case 'cruise-list-header-icon-specials':
          return position - 735
        case 'cruise-list-header-icon-classic-all-inclusive':
          return position - 495
        case 'cruise-list-header-icon-classic':
          return position - 390
        default:
          return position
      }
    },
    
    priceModelLabel: (priceModel: string) => {
      return mapPriceModelLabel(priceModel as IbePriceModelCode)
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.cruise-list-header-table-row {
  border-bottom: 2px solid $color-expinet-blue;
  height: $panel-header-height;
}

.table-cell-header {
  height: $panel-header-height;
}
</style>
